module.exports = "/images/vendor/desiigner-svg/svg/places/nature.svg?fb0b3df91d99360c0386b8b5b9fe45d3";